
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Gegevensbron',
	'dataSourceId': 'ID',
	'dataSourceType': 'Typen',
	'dataSourceName': 'Naam',
	'dataSourcePath': 'Pad',
	'showInfoForAll': 'Tijdsduur voor alle visualisaties afbeelden',
	'hideInfoForAll': 'Tijdsduur voor alle visualisaties verbergen',
	'showPerformanceDetails': 'Alle widgets opnieuw uitvoeren om prestatiegegevens op te nemen',
	'slotMappingField': 'Slottoewijzingen',
	'slotDataMapping': 'Toewijzing',
	'slotID': 'ID',
	'slotCaption': 'Bijschrift',
	'slotMandatory': 'Verplicht',
	'slotIsMandatory': 'Ja',
	'slotIsNotMandatory': 'Nee',
	'infoNotAvailable': 'Niet beschikbaar',
	'performanceSection': 'Prestatie',
	'durationField': 'Duur',
	'singleQueryTime': 'Serverquery (ms)',
	'multipleQueryTime': 'Serverquery %{name} (ms)',
	'liveWidgetTotalTime': 'Totaal (ms)',
	'renderTimeNotAvailable': 'Niet beschikbaar',
	'renderInProgress': '(wordt uitgevoerd)',
	'interactToTriggerQuery': 'Werk interactief met widget om een query te activeren',
	'fetchQuery': 'Query ophalen',
	'showSQLMDX': 'SQL/MDX afbeelden',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Querygegevens',
	'queryInfoNotAvailable': 'Querygegevens zijn niet beschikbaar',
	'query': 'Query',
	'copy': 'Kopiëren',
	'close': 'Sluiting'
});
